// ============================================================================
// Key Bindings Configuration
// ============================================================================
// Centralized key bindings for future rebinding support.
// All keys use KeyboardEvent.code values (e.g., 'KeyW', 'ArrowUp', 'F12')

export const KeyBindings = {
  // Camera movement (primary)
  CAMERA_UP: 'KeyW',
  CAMERA_DOWN: 'KeyS',
  CAMERA_LEFT: 'KeyA',
  CAMERA_RIGHT: 'KeyD',

  // Camera movement (alternate)
  CAMERA_UP_ALT: 'ArrowUp',
  CAMERA_DOWN_ALT: 'ArrowDown',
  CAMERA_LEFT_ALT: 'ArrowLeft',
  CAMERA_RIGHT_ALT: 'ArrowRight',

  // Modifiers
  MODIFIER: 'ShiftLeft',
  MODIFIER_ALT: 'ShiftRight',

  // Actions
  CANCEL: 'Escape',
  FIGHT_MODE: 'KeyF',
  CONSTRUCTION_PANEL: 'KeyB',

  // System
  FULLSCREEN: 'F12',
  DEBUG_MENU: 'F3',
} as const;

export type KeyBinding = (typeof KeyBindings)[keyof typeof KeyBindings];
